import React, { useMemo } from "react";
import styles from "../characteristicCustomForm.module.scss";
import { useSelector } from "react-redux";

export const ViewCustomForm = ({ getForm, customFormBuilder }) => {
  const showViewForm = useSelector((state) => state.forms.viewForms?.formdata || []);
  const forms = useSelector((state) => state.forms.formDetailsData);

  const viewForm = useMemo(() => getForm?.formdata || [], [getForm]);
  const formList = useMemo(() => customFormBuilder || [], [customFormBuilder]);
  const sectionInfo = useMemo(() => forms?.sectionInfo || [], [forms]);
  const questionMap = useMemo(() => new Map(formList.map((q) => [q.id, q])), [formList]);
  const answerMap = useMemo(() => new Map(viewForm.map((a) => [a.id, a])), [viewForm]);

  const sections = useMemo(() => {
    return sectionInfo.map((section) => ({
      ...section,
      questions: section.questionsId
        .map((id) => {
          const question = questionMap.get(id);
          const answer = answerMap.get(id);
          return question && answer ? { question, answer } : null;
        })
        .filter(Boolean),
    }));
  }, [sectionInfo, questionMap, answerMap]);

  const unSectioned = useMemo(() => {
    const sectionQuestionIds = new Set(sectionInfo.flatMap((s) => s.questionsId));
    return viewForm
      .filter((item) => !sectionQuestionIds.has(item.id))
      .map((item) => {
        const question = questionMap.get(item.id);
        return question ? { question, answer: item } : null;
      })
      .filter(Boolean);
  }, [viewForm, sectionInfo, questionMap]);

  if (!viewForm.length) return null;

  const renderValues = (question, answer) => {
    const options = answer?.options || [];

    if (!showViewForm.length) return "";
    if(question.type === "text") return answer?.value

    if (options.includes("noneoftheabove")) return <div className={`col-form-label ${styles.content_spec}`}>None of the above</div>;

    if (options.includes("alloftheabove")) {
      return question.options
        ?.filter((opt) => opt.key && !["alloftheabove", "noneoftheabove"].includes(opt.key))
        .map((opt, i) => (
          <div key={i} className={`col-form-label ${styles.content_spec}`}>
            {opt.key !== "other" ? opt.value : answer.value}
          </div>
        ));
    }

    if (options.length > 0) {
      return options.map((optKey, i) => {
        const optionData = question.options?.find((opt) => opt.key === optKey);
        return (
          <div key={i} className={`col-form-label ${styles.content_spec}`}>
            {optionData?.key !== "other" ? optionData?.value : answer.value}
          </div>
        );
      });
    }

    return answer.value;
  };

  const renderSection = (section) => (
    <div key={section.name} className={`col-12 ${styles.section}`}>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>{section.sectionPlaceholder}</span>
      </div>
      {section.questions.map(({ question, answer }) => (
        <div className={`col-12 ${styles.col_spec}`} key={question.id}>
          <label className={`col-6 col-form-label`}>
            <span className={styles.label_spec}>{question.desc}</span> <br />
            <span className={styles.coreDesc} style={{ fontSize: 14}}>{question.coreDesc}</span>
          </label>
          <div className="col-6 p-0">{renderValues(question, answer)}</div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      {sections.map(renderSection)}

      {unSectioned?.length > 0 && (
        <div className={`col-12 ${styles.section}`}>
          {unSectioned.map(({ question, answer }) => (
            <div className={`col-12 ${styles.col_spec}`} key={question.id}>
              <label className={`col-6 col-form-label`}>
                <span className={styles.label_spec}>{question.desc}</span> <br />
                <span className={styles.coreDesc} style={{ fontSize: 14}}>{question.coreDesc}</span>
              </label>
              <div className="col-5 p-0">{renderValues(question, answer)}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
